export default __webpack_public_path__ + "media/src/assets/images/DownArrow-c0a96f73610f9945fe89ca3e5dfec995.svg";